module.exports = __webpack_public_path__ + "img/topic-study.7a806b00.jpg";